import { Card } from "../common/Card";
import styles from "./SummaryCards.module.css";

/**
 * The figures at the top of the dashboard.
 *
 * cards: [{ label, value, tone?, sub? }]
 *
 * `sub` is a smaller line under the label, added for #295: on an account
 * that helps at somebody else's apiary, "Total Hives" was silently the
 * sum of yours and theirs. The big number stays YOURS -- that is the one
 * somebody reads at a glance and acts on -- and the split goes
 * underneath rather than into a sixth tile.
 *
 * No new tile on purpose. Five is already the width of the row, and a
 * sixth would reflow the grid for a distinction most accounts never have:
 * `sub` is simply absent for anybody not on a team, and the tile looks
 * exactly as it always did.
 */
export function SummaryCards({ cards }) {
  return (
    <div className={styles.grid}>
      {cards.map((c) => (
        <Card key={c.label} className={styles.card}>
          <div className={[styles.value, c.tone ? styles[c.tone] : ""].join(" ")}>{c.value}</div>
          <div className={styles.label}>{c.label}</div>
          {c.sub ? <div className={styles.sub}>{c.sub}</div> : null}
        </Card>
      ))}
    </div>
  );
}
